export const pageTitle = title => {
  return (document.title =
    title + ' -  Medayus - Medical and Healthcare React App');
};
